module.exports = __webpack_public_path__ + "static/media/background.7166768e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background.png
// module id = 70
// module chunks = 0